import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './UndoRedo.module.less';
import { TOP } from '../Popup/alignments';
import Tooltip from '../Popup/Tooltip';
import { translate } from '../../services/L10n';
import classNames from 'classnames';
import platform from '../../util/platform';
import { IconButton } from '../IconButton';
import { ButtonTypeEnum } from '@inter-ikea-kompis/component-button';
import { IconButtonSizeEnum } from '@inter-ikea-kompis/component-icon-button';
import { selectUserAgent } from '../../state/userAgent/userAgentSelectors';
import { thunkRedo, thunkUndo } from '../../state/tac/tacThunks';
import { selectIsWallResizerActive } from '../../state/scene/sceneSelectors.ts';
import {
  selectHasRedoHistory,
  selectHasUndoHistory,
} from '../../state/tac/tacSelectors.ts';
import { selectWriteDirection } from '../../state/dexfSettings/dexfSettingsSelectors';
import { t } from '../../translations';

const UndoRedo = () => {
  const canUndo = useSelector(selectHasUndoHistory);
  const canRedo = useSelector(selectHasRedoHistory);
  const userAgent = useSelector(selectUserAgent);
  const wallResizerActive = useSelector(selectIsWallResizerActive);
  const writeDirection = useSelector(selectWriteDirection);

  const dispatch = useDispatch();
  const onUndo = () => dispatch(thunkUndo());
  const onRedo = () => dispatch(thunkRedo());

  const isKiosk = platform.isKiosk;
  const iconSize = isKiosk
    ? IconButtonSizeEnum.medium
    : IconButtonSizeEnum.small;

  return !wallResizerActive || userAgent.isMobile ? (
    <div className={classNames(styles.wrapper)}>
      <Tooltip alignment={TOP} content={translate(t.TOOLTIP_UNDO)}>
        <IconButton
          iconName={
            writeDirection === 'ltr'
              ? 'ArrowUTurnBackwardsIcon'
              : 'ArrowUTurnForwardsIcon'
          }
          size={iconSize}
          type={ButtonTypeEnum.secondary}
          disabled={!canUndo}
          onClick={onUndo}
          data-testid="undo-button"
        />
      </Tooltip>

      <Tooltip alignment={TOP} content={translate(t.TOOLTIP_REDO)}>
        <IconButton
          iconName={
            writeDirection === 'ltr'
              ? 'ArrowUTurnForwardsIcon'
              : 'ArrowUTurnBackwardsIcon'
          }
          size={iconSize}
          type={ButtonTypeEnum.secondary}
          disabled={!canRedo}
          onClick={onRedo}
          data-testid="redo-button"
        />
      </Tooltip>
    </div>
  ) : null;
};

export default UndoRedo;
